import { Component, inject, OnInit, signal } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ActivatedRoute, Router } from '@angular/router'
import { PaymentComponent } from '../../components/payment/payment.component'
import { TranslatePipe } from '../../core/pipes/translate.pipe'
import { PaymentService, PaymentStatus } from '../../services/payment.service'
import { BrandingService } from '../../services/branding.service'

/**
 * Página de pago que el paciente abre desde el email.
 * Ruta: /pago/:consultationId
 *
 * No requiere login — accesible por link público.
 */
@Component({
  selector: 'app-payment-page',
  standalone: true,
  imports: [CommonModule, PaymentComponent, TranslatePipe],
  templateUrl: './payment-page.component.html',
  styleUrl: './payment-page.component.scss',
})
export class PaymentPageComponent implements OnInit {
  readonly branding = inject(BrandingService)
  private route = inject(ActivatedRoute)
  private router = inject(Router)
  private paymentSvc = inject(PaymentService)

  consultationId = signal<string | null>(null)
  status = signal<PaymentStatus | null>(null)
  loading = signal(true)
  error = signal<string | null>(null)

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('consultationId')
    if (!id) {
      this.error.set('Consulta no encontrada')
      this.loading.set(false)
      return
    }

    this.consultationId.set(id)
    this.paymentSvc.getPaymentStatus(id).subscribe({
      next: (s) => {
        this.status.set(s)
        this.loading.set(false)
      },
      error: () => {
        this.error.set('No se pudo cargar la información del pago')
        this.loading.set(false)
      },
    })
  }

  onPaymentSuccess(): void {
    this.router.navigate(['/pago-completado'], { queryParams: { redirect_status: 'succeeded' } })
  }

  get alreadyPaid(): boolean {
    return this.status()?.pendingPayment === false
  }

  get formattedAmount(): string {
    const s = this.status()
    if (!s?.amount) return ''
    return PaymentService.formatAmount(s.amount, s.currency ?? 'eur')
  }
}
